import { PaletteColor } from '@mui/material'

declare module '@mui/material/styles' {
	interface Palette {
		gameSimonSays: Palette['primary']
	}

	interface PaletteOptions {
		gameSimonSays?: PaletteOptions['primary']
	}
}

declare module '@mui/material/Alert' {
	interface AlertPropsColorOverrides {
		gameSimonSays: true
	}
}

export const gameSimonSaysColor = {
	main: '#A875FF',
	light: '#F1ECF8',
} as PaletteColor
